'use client'
import { EPageName } from "@/util/enum"
import BeforeAfterSlider, { BeforeAfterSliderProps } from "@/components/ui/cardSection/BeforeAfterSlider"
import SwiperWithArrow from "@/components/ui/swiper/SwiperWithArrow"


export interface CrouselBeforeAndAfterIndexProps{
    beforeAndAfterData:BeforeAfterSliderProps[]
}

const CrouselBeforeAndAfterIndex = ({beforeAndAfterData}:CrouselBeforeAndAfterIndexProps) => {
    return (
        <div className="w-full mt-2.5 px-0 md:px-2 xl:px-20">
            <SwiperWithArrow
                pageName={EPageName?.SLIDER}
                crouselData={beforeAndAfterData}
                pauseAutoplayOnSlideInteraction
                renderItem={(item) => (
                    <BeforeAfterSlider
                        beforeImage={item.beforeImage}
                        afterImage={item.afterImage}
                        before_alt_name={item.before_alt_name}
                        after_alt_name={item.after_alt_name}
                    />
                )}
            />
        </div>
    )
}

export default CrouselBeforeAndAfterIndex